import { render } from "./ImportConsultants.vue?vue&type=template&id=4bfd87a6"
import script from "./ImportConsultants.vue?vue&type=script&lang=js"
export * from "./ImportConsultants.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__